import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.66699 4.08594H16.3337V2.58594H3.66699V4.08594ZM16.3337 15.9193H3.66699V17.4193H16.3337V15.9193ZM2.41699 14.6693V5.33594H0.916992V14.6693H2.41699ZM17.5837 5.33594V10.0026H19.0837V5.33594H17.5837ZM17.5837 10.0026V14.6693H19.0837V10.0026H17.5837ZM3.66699 15.9193C2.97664 15.9193 2.41699 15.3596 2.41699 14.6693H0.916992C0.916992 16.1881 2.14821 17.4193 3.66699 17.4193V15.9193ZM16.3337 17.4193C17.8524 17.4193 19.0837 16.1881 19.0837 14.6693H17.5837C17.5837 15.3596 17.024 15.9193 16.3337 15.9193V17.4193ZM16.3337 4.08594C17.024 4.08594 17.5837 4.64558 17.5837 5.33594H19.0837C19.0837 3.81716 17.8524 2.58594 16.3337 2.58594V4.08594ZM3.66699 2.58594C2.14821 2.58594 0.916992 3.81715 0.916992 5.33594H2.41699C2.41699 4.64558 2.97664 4.08594 3.66699 4.08594V2.58594Z",
			fill: "#4B525D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.45508 7.03906H14.546",
			stroke: "#4B525D",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.45508 10H14.546",
			stroke: "#4B525D",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.45508 12.9648H9.24296",
			stroke: "#4B525D",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		})
	]
});
export default SvgNote;
